"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledStandardCard = exports.SectionHeader = exports.Section = exports.PreLineCopy = exports.PageHeader = exports.MobileCentered = exports.MarginTopSection = exports.FooterApplyContainer = exports.CompareOffersButton = exports.BlueStripe = exports.ApplyButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _index = _interopRequireDefault(require("../match-factor-score/index.js"));

var _offerLinkAttributes = require("../util/offer-link-attributes.js");

var _jsxRuntime = require("react/jsx-runtime");

var StyledStandardCard = (0, _styledComponents["default"])(_baseReactComponents.StandardCard).withConfig({
  displayName: "StyledStandardCard",
  componentId: "sc-1fmll0a-0"
})(["padding-top:0;padding-left:0;padding-right:0;"]);
exports.StyledStandardCard = StyledStandardCard;

var Section = _styledComponents["default"].div.withConfig({
  displayName: "Section",
  componentId: "sc-1fmll0a-1"
})(["margin:0 auto;padding:12px 24px 6px;max-width:868px;"]);

exports.Section = Section;
var MarginTopSection = (0, _styledComponents["default"])(Section).withConfig({
  displayName: "MarginTopSection",
  componentId: "sc-1fmll0a-2"
})(["margin-top:12px;"]);
exports.MarginTopSection = MarginTopSection;
var FooterApplyContainer = (0, _styledComponents["default"])(Section).withConfig({
  displayName: "FooterApplyContainer",
  componentId: "sc-1fmll0a-3"
})(["padding:48px 24px 24px;display:flex;flex-direction:column;align-items:center;gap:28px;text-align:center;@media (", "){flex-direction:row;justify-content:flex-start;text-align:inherit;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.forLargerThanPhone;
});
exports.FooterApplyContainer = FooterApplyContainer;

var TopHeaderFlex = _styledComponents["default"].div.withConfig({
  displayName: "TopHeaderFlex",
  componentId: "sc-1fmll0a-4"
})(["display:flex;flex-direction:column;align-items:center;gap:12px;padding:6px 0 12px 0;@media (", "){flex-direction:row;justify-content:space-between;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.forLargerThanPhone;
});

var Logo = _styledComponents["default"].img.withConfig({
  displayName: "Logo",
  componentId: "sc-1fmll0a-5"
})(["display:block;max-width:160px;"]);

var OfferCopy = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "OfferCopy",
  componentId: "sc-1fmll0a-6"
})(["margin:12px 0;&::-moz-selection{background-color:", ";}&::selection{background-color:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.scuttleGray300;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.scuttleGray300;
});
var StyledMatchFactorScore = (0, _styledComponents["default"])(_index["default"]).withConfig({
  displayName: "StyledMatchFactorScore",
  componentId: "sc-1fmll0a-7"
})(["width:max-content;margin-top:8px;"]);

var MobileCentered = _styledComponents["default"].div.withConfig({
  displayName: "MobileCentered",
  componentId: "sc-1fmll0a-8"
})(["display:flex;flex-direction:column;align-items:center;text-align:center;@media (", "){display:block;text-align:inherit;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.forLargerThanPhone;
});

exports.MobileCentered = MobileCentered;

var PageHeaderButtons = _styledComponents["default"].div.withConfig({
  displayName: "PageHeaderButtons",
  componentId: "sc-1fmll0a-9"
})(["display:flex;flex-direction:column;gap:16px;align-items:center;"]);

var CompareOffersButton = function CompareOffersButton(_ref6) {
  var href = _ref6.href;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Button, {
    "data-testid": "marketplace-details-page:compare-button",
    href: href,
    size: "large",
    variation: "buttonLink",
    children: "Compare offers"
  });
};

exports.CompareOffersButton = CompareOffersButton;

var PageHeader = function PageHeader(_ref7) {
  var _offer$image$high, _offer$image;

  var offer = _ref7.offer,
      buttons = _ref7.buttons,
      _ref7$shouldShowMatch = _ref7.shouldShowMatchFactorDescriptionDrawer,
      shouldShowMatchFactorDescriptionDrawer = _ref7$shouldShowMatch === void 0 ? false : _ref7$shouldShowMatch;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Section, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(TopHeaderFlex, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(MobileCentered, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Logo, {
          src: (_offer$image$high = (_offer$image = offer.image) === null || _offer$image === void 0 ? void 0 : _offer$image.high) !== null && _offer$image$high !== void 0 ? _offer$image$high : '',
          alt: "".concat(offer.issuer, " logo")
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(OfferCopy, {
          bold: true,
          size: "lg",
          children: offer.name
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMatchFactorScore, {
          showInfoIcon: true,
          score: offer.matchFactor,
          shouldShowMatchFactorDescriptionDrawer: shouldShowMatchFactorDescriptionDrawer
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PageHeaderButtons, {
        children: buttons
      })]
    })
  });
};

exports.PageHeader = PageHeader;

var BlueStripe = _styledComponents["default"].div.withConfig({
  displayName: "BlueStripe",
  componentId: "sc-1fmll0a-10"
})(["background-color:", ";padding:12px 0;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.bubbleBlue200;
});

exports.BlueStripe = BlueStripe;
var SectionHeader = (0, _styledComponents["default"])(_baseReactComponents.Header).withConfig({
  displayName: "SectionHeader",
  componentId: "sc-1fmll0a-11"
})(["margin-top:32px;margin-bottom:8px;"]);
exports.SectionHeader = SectionHeader;
SectionHeader.defaultProps = {
  size: 'xl'
};
var PreLineCopy = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "PreLineCopy",
  componentId: "sc-1fmll0a-12"
})(["white-space:pre-line;"]);
exports.PreLineCopy = PreLineCopy;

var ApplyButton = function ApplyButton(_ref9) {
  var shouldHide = _ref9.shouldHide,
      applyUrl = _ref9.applyUrl,
      onClick = _ref9.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Button, Object.assign({
    asAnchor: true,
    disabled: shouldHide,
    rel: "noopener noreferrer",
    target: "_blank",
    size: "large"
  }, (0, _offerLinkAttributes.offerLinkAttributes)(shouldHide ? null : applyUrl !== null && applyUrl !== void 0 ? applyUrl : ''), {
    "data-testid": "marketplace-details-page:apply-button",
    onClick: onClick,
    children: "I'm ready to apply"
  }));
};

exports.ApplyButton = ApplyButton;
//# sourceMappingURL=common.js.map